import { faSearch, faUser, faXmark } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import getAbsoluteLogoURL from "global/helpers";
import { UpdateCompanyBrandingModel } from "services/classes/UpdateCompanyBrandingModel";

type CompanyBrandingPreviewProps = {
  isPreviewOpen: boolean;
  setPreviewOpen: React.Dispatch<React.SetStateAction<boolean>>;
  values: UpdateCompanyBrandingModel;
  logoLocalURL: string | null | undefined;
};

const CompanyBrandingPreview = (props: CompanyBrandingPreviewProps) => {
  function preventDefault(e: React.MouseEvent<HTMLElement, MouseEvent>) {
    e.preventDefault();
  }

  return (
    <div className={`preview-container ${props.isPreviewOpen ? "show" : ""}`}>
      <div className="preview-container-close">
        <FontAwesomeIcon
          data-test-id="company-branding-preview-panel__close-button"
          className="preview-close-btn"
          icon={faXmark}
          onClick={() => props.setPreviewOpen(false)}
        />
      </div>
      <div className="preview-container-main">
        <div className="preview-navbar" style={{ backgroundColor: props.values.navbarBackgroundColour }}>
          <img className="preview-logo" src={props.logoLocalURL ?? getAbsoluteLogoURL()}></img>
          <div className="preview-navbar-items">
            <button
              data-test-id="company-branding-preview-panel__navbar-button-1"
              className="btn preview-btn navbar"
              style={{ backgroundColor: props.values.navbarButtonColour, color: props.values.navbarButtonTextColour }}
              onClick={preventDefault}
            >
              <span className="preview-navbar-btn-text">Navbar Button</span>
            </button>
            <button
              data-test-id="company-branding-preview-panel__navbar-button-2"
              className="btn preview-btn navbar"
              style={{ backgroundColor: props.values.navbarButtonColour, color: props.values.navbarButtonTextColour }}
              onClick={preventDefault}
            >
              <span className="preview-navbar-btn-text">Navbar Button</span>
            </button>
            <button
              data-test-id="company-branding-preview-panel__navbar-button-3"
              className="btn preview-btn navbar"
              style={{ backgroundColor: props.values.navbarButtonColour, color: props.values.navbarButtonTextColour }}
              onClick={preventDefault}
            >
              <span className="preview-navbar-btn-text">Navbar Button</span>
            </button>
          </div>
        </div>
        <div className="preview-main">
          <div className="preview-toolbar" style={{ backgroundColor: props.values.toolbarBackgroundColour }}>
            <div className="input-group preview-global-search" style={{ width: "35%" }}>
              <input
                data-test-id="company-branding-preview-panel__global-search-input"
                className="form-control"
                type="text"
                placeholder="Search..."
                aria-label="Global search"
              />
              <div className="input-group-append global-search-search-button">
                <button
                  data-test-id="company-branding-preview-panel__global-search-button"
                  className="btn btn-sm"
                  type="button"
                  aria-valuetext="Global Search"
                >
                  <FontAwesomeIcon icon={faSearch} aria-hidden="true" />
                  <div aria-label="Search button" hidden>
                    Search
                  </div>
                </button>
              </div>
            </div>
            <div>
              <span className="me-2" style={{ color: props.values.fontBodyColour }}>
                Username
              </span>
              <FontAwesomeIcon
                icon={faUser}
                aria-hidden="true"
                className="cursor-pointer"
                style={{
                  color: props.values.toolbarButtonColour,
                }}
                size="xl"
              />
            </div>
          </div>
          <div className="preview-content">
            <h3
              className="preview-header"
              style={{
                color: props.values.fontHeadingColour,
                fontStyle: props.values.isHeaderTextItalic ? "italic" : "normal",
                fontWeight: props.values.isHeaderTextBold ? "bold" : "normal",
                textDecorationLine: props.values.isHeaderTextUnderlined ? "underline" : "none",
              }}
            >
              Header text
            </h3>
            <div className="card preview-content-card">
              <div className="card-body preview-content-card-body">
                <div style={{ color: props.values.fontBodyColour }} className="mb-2">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec sed rhoncus nisl. Nam felis elit,
                  gravida ac tincidunt non, ultricies a dolor. Proin vulputate massa a malesuada ultrices. In accumsan
                  blandit turpis, et consectetur tellus ultrices non. Fusce volutpat purus ac rhoncus mollis.
                  Suspendisse at elementum risus, ut varius mi. Aenean eu placerat nulla. Class aptent taciti sociosqu
                  ad litora torquent per conubia nostra, per inceptos himenaeos.
                </div>
                <button
                  data-test-id="company-branding-preview-panel__primary-button"
                  className="btn btn-primary preview-btn mb-2"
                  style={{
                    backgroundColor: props.values.buttonPrimaryColour,
                    color: props.values.buttonPrimaryTextColour,
                  }}
                  onClick={preventDefault}
                >
                  Primary Button
                </button>
                <button
                  data-test-id="company-branding-preview-panel__secondary-button"
                  className="btn btn-secondary preview-btn mb-2"
                  style={{
                    backgroundColor: props.values.buttonSecondaryColour,
                    color: props.values.buttonSecondaryTextColour,
                  }}
                  onClick={preventDefault}
                >
                  Secondary Button
                </button>
                <button
                  data-test-id="company-branding-preview-panel__danger-button"
                  className="btn btn-danger preview-btn mb-2"
                  style={{
                    backgroundColor: props.values.buttonDangerColour,
                    color: props.values.buttonDangerTextColour,
                  }}
                  onClick={preventDefault}
                >
                  Danger Button
                </button>
                <button
                  data-test-id="company-branding-preview-panel__success-button"
                  className="btn btn-success preview-btn mb-2"
                  style={{
                    backgroundColor: props.values.buttonSuccessColour,
                    color: props.values.buttonSuccessTextColour,
                  }}
                  onClick={preventDefault}
                >
                  Success Button
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanyBrandingPreview;
